/** `clientName` is free text: the backend has no first/last split and clinic-software names like "Wilson family" don't split. */
export const PatientClientName = ({
  patientName,
  clientName,
}: {
  patientName: string;
  clientName?: string | null;
}) => (
  <>
    {patientName}
    {clientName && (
      <span className="font-normal text-annotation"> – {clientName}</span>
    )}
  </>
);
